//
// Bridge between the axios layer (client/lib/api/index.js) and the React tree.
// Neither can import the other: axios interceptors are plain module code and
// must not pull React in, while the CAPTCHA puzzle has to be rendered from
// inside a response interceptor.
//
// <WafGate/> registers a handler on mount; the response interceptor calls
// requestCaptchaSolve() when AWS WAF answers a request with a CAPTCHA challenge
// (HTTP 405), then retries the original request once the puzzle resolves.
//

type CaptchaHandler = () => Promise<string>

let captchaHandler: CaptchaHandler | null = null

export const registerCaptchaHandler = (fn: CaptchaHandler): void => {
  captchaHandler = fn
}

export const unregisterCaptchaHandler = (): void => {
  captchaHandler = null
}

export const requestCaptchaSolve = (): Promise<string> =>
  captchaHandler ? captchaHandler() : Promise.reject(new Error('No AWS WAF CAPTCHA handler registered'))
